import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import htmlToText from 'scoreboard/components/html-to-text'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { RECORD_LIST, DASHBOARD } = FormWidgetType

/**
 * Provides a list of unique options given a list of form widgets
 */
export default function(widgets, opts = {}, context) {
	if (_.isEmpty(widgets)) return []
	if (opts.type) widgets = _.filter(widgets, w => w.type === opts.type)

	const properties = [
		{ property: 'type', labelFn: (p) => i18n.get(`forms.widgets.widget.${p}`) },
		{ property: 'buttonLabel', labelFn: (p, widgetType) =>
				widgetType === RECORD_LIST ? '' : p },
		{ property: 'label' },
		{ property: 'html', labelFn: (p) => htmlToText(p) },
		{ property: 'description' },
		{ property: 'fieldId', labelFn: (p) => {
				const field = context?.model?.dataset?.combinedFieldsById[p]
				return field ? field.label : ''
			}
		},
	]

	// #58477
	// If there are more than one DASHBOARD type widgets, append a number to
	// the label starting from 1
	let dashboardCount = _.filter(widgets,
			w => w?.type === DASHBOARD).length
	let dashboardLabelCount = 1

	_.each(widgets, w => w.selectLabel = '')
	let unique = _.groupBy(widgets, 'selectLabel')
	for (const p of properties) {
		_.each(widgets, w => {
			// only keep adding to the label if it isn't already unique
			// or if it is unique but blank
			if (_.size(unique[w.selectLabel]) > 1 || _.isEmpty(w.selectLabel)) {
				let labelFn = p.labelFn || _.identity
				let nextVal = _.isNil(w[p.property]) ?
					'' : labelFn(w[p.property], w.type)
				if (_.isEmpty(w.selectLabel)) {
					w.selectLabel = nextVal
				} else if (!_.isEmpty(nextVal)) {
					w.selectLabel += `: ${nextVal}`
				}

				if (w.type === DASHBOARD && dashboardCount > 1) {
					w.selectLabel += `: ${dashboardLabelCount}`
					dashboardLabelCount++
				}
			}
		})
		unique = _.groupBy(widgets, 'selectLabel')
		if (_.size(widgets) === _.size(unique)) break
	}
	return _.map(widgets, w => ({
		label: w.selectLabel,
		value: w.id || w.tempId
	}))
}